class CuotitasError extends Error {
  constructor(error) {
    super(error.message);
    this.description = error.message;
    this.type = error.type;
    this.code = error.response?.data?.extra?.code
  }
}

export default CuotitasError;
